import { useEffect, useState } from "react";
import useAircraft from "./useAircraft";

/**
 * A hook that calculates and returns the remaining flight time for a specific aircraft.
 * The hook automatically updates the remaining time every second.
 *
 * @param {string} aircraftIdent - The unique identifier of the aircraft.
 * @returns {number} remaining - The remaining flight time in milliseconds.
 */
function useRemainingFlightTime(aircraftIdent) {
	const [remaining, setRemaining] = useState(0);
	const aircraft = useAircraft(aircraftIdent);

	useEffect(() => {
		if (!aircraft || !["inflight", "delivery"].includes(aircraft.status)) return;
		const interval = setInterval(() => setRemaining(aircraft.getRemainingFlightTime() * 1000), 1000);
		return () => clearInterval(interval);
	}, [aircraft, aircraft.status]);

	return remaining;
}

export default useRemainingFlightTime;
